import { BCMSDate, BCMSStateManagerCRUD, useModel } from "@bcm-dev/bcms-vite";
import ChatPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/ChatPage";
import ChatItem from "components/pages/ChatPage/classes/ChatItem";

/**
 * @function CaptureChatSelectLanguage
 * @return {React.Component}
 * @exported true
 * @description Capture component for "008_Chat_SelectLanguage".
 */
export default function CaptureChatSelectLanguage(props) {
    const { branding } = useModel();
    const options = branding.options || {};
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(options))
        .update([ "showInitialMessage" ], false)
        .update([ "showTranslationPopup" ], true)        
        .submit();

    return <ChatPage ui={ ui } />
}